var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Prop, Vue } from 'vue-property-decorator';
import ActionDialogLayout from '@/views/Groups/Tabs/Actions/Dialogs/ActionDialogLayout/ActionDialogLayout.vue';
import { Group } from '@/models/Group';
import SubjectLevelSelector from '@/views/Groups/Tabs/Actions/Dialogs/Selectors/SubjectLevelSelector/SubjectLevelSelector.vue';
import StudentSelector from '@/views/Groups/Tabs/Actions/Dialogs/Selectors/StudentSelector/StudentSelector.vue';
import LabelValue from '@/components/LabelValue.vue';
import ErrorHandler from '@/support/ErrorHandler';
import { User } from '@/models/User';
let DownloadThisIsMeDialog = class DownloadThisIsMeDialog extends Vue {
    constructor() {
        // #region @VModel
        // #endregion
        super(...arguments);
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.selectedStudents = {};
        this.students = [];
        this.selectedAll = false;
        this.currentStep = 1;
        this.isLoading = false;
        this.archiveTitle = '';
        this.portfolios = [];
        // #endregion
        // #region @Watchers
        // #endregion
    }
    // #endregion
    // #region Lifecycle Hooks
    // #endregion
    // #region Event handlers
    // #endregion
    // #region Class methods
    onClose() {
        this.$emit('close');
    }
    onSelectedStudents(value) {
        this.$set(this, 'selectedStudents', value);
    }
    onCurrentStepChanged(value) {
        this.currentStep = value;
        if (this.currentStep === 2) {
            // this.fetchStudentPortfolios();
        }
    }
    // #endregion
    // #region Async methods (api calls only)
    async fetchStudentPortfolios() {
        if (!Object.keys(this.selectedStudents).length) {
            return;
        }
        this.isLoading = true;
        try {
            const studentIds = Object.keys(this.selectedStudents).filter((key) => this.selectedStudents[key]);
            this.students = this.group.users.filter((user) => studentIds.includes(user.id)) || {};
            const response = await new User().downloadPortfolios({
                users: studentIds,
                name: this.archiveTitle,
            });
            this.$emit('submitted');
        }
        catch (error) {
            ErrorHandler.network(error);
        }
        finally {
            this.isLoading = false;
        }
    }
    // #endregion
    // #region Getters & Setters
    get isDisabled() {
        switch (this.currentStep) {
            case 1:
                return (Object.keys(this.selectedStudents).every((key) => {
                    return this.selectedStudents[key] === false;
                }) || Object.keys(this.selectedStudents).length === 0);
            case 2:
                return !this.archiveTitle;
            default:
                return false;
        }
    }
    get required() {
        return (value) => {
            return !!value || 'Field is required';
        };
    }
    get dialogDescription() {
        return this.$tc('It can take up to 7 or 10 minutes to receive the downloaded items in your mailbox. If not, double check you SPAM folder or the helpdesk.');
    }
    get dialogOptions() {
        return {
            steps: [
                { label: this.$tc('Select students'), value: 1 },
                { label: this.$tc('Portfolio label'), value: 2 },
            ],
            title: this.$tc('Download "This is me"'),
            description: this.dialogDescription,
            customButtons: [
                {
                    label: 'Download',
                    action: () => {
                        this.fetchStudentPortfolios();
                    },
                    visible: this.currentStep === 2,
                    disabled: this.isDisabled,
                },
            ],
        };
    }
};
__decorate([
    Prop({ required: true }),
    __metadata("design:type", typeof (_a = typeof Group !== "undefined" && Group) === "function" ? _a : Object)
], DownloadThisIsMeDialog.prototype, "group", void 0);
DownloadThisIsMeDialog = __decorate([
    Component({
        components: {
            ActionDialogLayout,
            SubjectLevelSelector,
            StudentSelector,
            LabelValue,
        },
    })
], DownloadThisIsMeDialog);
export default DownloadThisIsMeDialog;
// #endregion
// #region Constants
// #endregion
